import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EditableQuestion, Question, Section } from '../model/inaSchoolEnrollments';
import { ServiceAdministrationService } from 'src/app/component/service-administration/service/service-administration.service';
import { ServiceName } from '../model/serviceName';
import { INAAction } from '../../model/ina-action';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { InaSchoolEnrollment2 } from '../../model/ina-school-enrollment-sections';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';




@Component({
  selector: 'app-learning-plan',
  templateUrl: './learning-plan.component.html',
  styleUrls: ['./learning-plan.component.scss']
})



export class LearningPlanComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;

  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() valid = new EventEmitter<boolean>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();

  editing: boolean = true;

  frmLearningPlan: UntypedFormGroup;
  section: Section;
  inaSchoolEnrollment: InaSchoolEnrollment2;
  shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;

  lookupInstructionalService: ServiceName[] = [];
  lstInstructionalService: ServiceName[] = [];
  boolPnlOpenStateIS: boolean = false;
  instructionalServiceQuestions: Question[];

  lookupSupportService: ServiceName[] = [];
  lstSupportService: ServiceName[] = [];
  boolPnlOpenStateSS: boolean = false;
  supportServiceQuestions: Question[];

  goalEditableQuestions: EditableQuestion[] = []; //outgoing, Send data to child component

  nonMEPEditableQuestions: EditableQuestion[] = [];//outgoing, Send data to child component
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();

  constructor(
    private fb: UntypedFormBuilder, 
    public serviceAdministration: ServiceAdministrationService, 
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];
    this.frmLearningPlan = this.fb.group({

    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.fireValidation();
    }, 3000)
  }
  fireValidation() {
    if (this.action != INAAction.View) {
      if (this.lstInstructionalService.length > 0 || this.lstSupportService.length > 0) {
        this.frmLearningPlan.setErrors(null);
      }
      else {
        this.frmLearningPlan.setErrors({ required: true, invalid: 'select atleast one recommended service either from Instructional or Support ' });
      }
      let validator: boolean = (this.frmLearningPlan.errors?.['required'] == true) ? false : true;
      this.valid.emit(validator);
    }
  }


  ngOnInit(): void {
    let sectionId: number = 27;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.inaSchoolEnrollment = x.inaSchoolEnrollment.InaSchoolEnrollment;
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
    });


    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });



    this.getQuestions('Goals').forEach(
      (element) => {
        this.goalEditableQuestions.push({ isEdit: false, question: element, isDelete: false });
      }
    )

    this.getQuestions('Non MEP Services').forEach(
      (element) => {
        this.nonMEPEditableQuestions.push({ isEdit: false, question: element, isDelete: false });
      }
    )

    this.instructionalServiceQuestions = this.getQuestions('Recommended Instructional Services');
    this.supportServiceQuestions = this.getQuestions('Recommended Support Services');

    this.invokeInstructionalService();
    this.invokeSupportService();


  }

  pOpenStateIS(pState: boolean) {
    this.boolPnlOpenStateIS = pState;
    if (!this.boolPnlOpenStateIS && this.IdentifyChange()) {
      this.updateChangeValue();
    }
  }

  removeIS(p: ServiceName) {
    this.lstInstructionalService = this.lstInstructionalService.filter(obj => obj.ID !== p.ID)
    if (this.IdentifyChange()) {
      this.updateChangeValue();
    }
  }
  pOpenStateSS(pState: boolean) {
    this.boolPnlOpenStateIS = pState;
    if (!this.boolPnlOpenStateIS && this.IdentifyChange()) {
      this.updateChangeValue();
    }
  }

  removeSS(p: ServiceName) {
    this.lstSupportService = this.lstSupportService.filter(obj => obj.ID !== p.ID)
    if (this.IdentifyChange()) {
      this.updateChangeValue();
    }
  }

  getQuestions(matchquery: string): Question[] {
    let tempRetQuestion = this.section.Questions.filter(x => x.Name.toString().match(matchquery)).filter(y => y.lstQuestionValueDataView[0].Value != "");
    return tempRetQuestion;
  }


  addRow(type: string) {
    if (this.editing) {
      if (type == 'Goals') {
        this.goalEditableQuestions.findIndex((x) => x.isEdit == true) == -1
          ? (this.goalEditableQuestions = [
            { isEdit: true, isDelete: false, question: this.buildQuestion(type) },
            ...this.goalEditableQuestions
          ])
          : null;
      }
      else {
        this.nonMEPEditableQuestions.findIndex((x) => x.isEdit == true) == -1
          ? (this.nonMEPEditableQuestions = [
            { isEdit: true, isDelete: false, question: this.buildQuestion(type) },
            ...this.nonMEPEditableQuestions
          ])
          : null;
      }
    }
  }
  buildQuestion(matchquery: string): Question {
    return this.section.Questions.filter(x => x.Name.toString().match(matchquery)).filter(y => y.lstQuestionValueDataView[0].Value == "")[0]
  }



  /*setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }

  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action: number) {
    
      let s: StepAction = new StepAction();
      s.stepNumber = 10;
      s.action = action == 1 ? '': this.notifyAction ;
      s.section = new Section();
      //Refactor the code to identify the comment change
      if (this.IdentifyChange()) {
        this.updateChangeValue();
        s.section = this.section;
        s.lsttrackingHistory = this.lstTrackHistory;
        this.lstTrackHistory=[];    
      }    
      this.prevOrNextStep.emit(s);    

  }
  */

  updateChangeValue() {
    this.section.Questions.forEach(x => {
      if (x.Id == 471) {
        let ids = this.lstInstructionalService.map((x => x.ID));
        x.lstQuestionValueDataView[0].Value = ids.toString();
      }
      if (x.Id == 472) {
        let ids = this.lstSupportService.map((x => x.ID));
        x.lstQuestionValueDataView[0].Value = ids.toString();
      }
    })
    this.shared.updateSections(this.section,0);
    this.shared.updateCacheSection(this.section);
    this.fireValidation();

  }

  invokeInstructionalService() {

    let payLoad = '';
    if (this.action == 3) {
      payLoad = '{"regionID":' + this.inaSchoolEnrollment.RegionId + ',"grades":[' + this.inaSchoolEnrollment.GradeId + '],"checkAllGrades":true,"instructionalOnly":true}';
    }
    else {
      payLoad = '{"regionID":' + this.inaSchoolEnrollment.RegionId + ',"activeServicesOnly":true,"grades":[' + this.inaSchoolEnrollment.GradeId + '],"checkAllGrades":true,"instructionalOnly":true}';
    }
    this.serviceAdministration.postIndex(payLoad).subscribe(x => {
      this.lookupInstructionalService = JSON.parse(x['partyServices']);
      if (this.instructionalServiceQuestions?.length > 0) {
        let serviceIds = this.instructionalServiceQuestions[0].lstQuestionValueDataView[0].Value.split(',')
        serviceIds.forEach(id => {
          let a = this.lookupInstructionalService.find(lookupService => lookupService.ID.toString() == id);
          if (a) {
            this.lstInstructionalService.push(a);
          }
        });
      }

    });
  }

  invokeSupportService() {
    let payLoad = '';
    if (this.action == 3) {
      payLoad = '{"regionID":' + this.inaSchoolEnrollment.RegionId + ',"grades":[' + this.inaSchoolEnrollment.GradeId + '],"checkAllGrades":true,"supportOnly":true}';
    }
    else {
      payLoad = '{"regionID":' + this.inaSchoolEnrollment.RegionId + ',"activeServicesOnly":true,"grades":[' + this.inaSchoolEnrollment.GradeId + '],"checkAllGrades":true,"supportOnly":true}';
    }
    this.serviceAdministration.postIndex(payLoad).subscribe(x => {
      this.lookupSupportService = JSON.parse(x['partyServices']);
      if (this.supportServiceQuestions?.length > 0) {
        let serviceIds = this.supportServiceQuestions[0]?.lstQuestionValueDataView[0]?.Value.split(',')
        serviceIds?.forEach(id => {
          let tempService = this.lookupSupportService.find(lookupService => lookupService.ID.toString() == id);
          if (tempService) {
            this.lstSupportService.push(tempService);
          }
        })
      }

    });
  }

  OperationCUD(action: string) {

    if (action == 'cancelled') {
      this.goalEditableQuestions = this.goalEditableQuestions.filter((g: EditableQuestion) => g.isEdit != true);
      this.nonMEPEditableQuestions = this.nonMEPEditableQuestions.filter((g: EditableQuestion) => g.isEdit != true);
    }
    else {
      let questionId: number = Number(action);
      let updatedGoalEditableQuestion = this.goalEditableQuestions.find(x => x.question.Id == questionId);
      let updatedNonMEPEditableQuestion = this.nonMEPEditableQuestions.find(x => x.question.Id == questionId);

      if (updatedGoalEditableQuestion) {
        this.section.Questions.forEach(x => {
          if (x.Id == questionId) {
            if (updatedGoalEditableQuestion?.question.lstQuestionValueDataView[0].Value == '') {
              let deletedComment:string  = x.lstQuestionValueDataView[0]?.Value.split("|")[4];                            
              let changedField: string = this.section.SectionID + ',' + questionId;
              this.setTrackingHistory2(x.Id,x.Name,'Deleted : ' + deletedComment);              

              x.lstQuestionValueDataView[0].Value = '';
              this.goalEditableQuestions = this.goalEditableQuestions.filter((g: EditableQuestion) => g.question.Id != questionId);                            
              
            }
            else {              
              let editedComment:string =x.lstQuestionValueDataView[0]?.Value.split("|")[4];              
              let changedField: string = this.section.SectionID + ',' + questionId;
              if(editedComment?.length>=1)   
                this.setTrackingHistory2(x.Id,x.Name,editedComment);

              x.lstQuestionValueDataView[0].Value = updatedGoalEditableQuestion?.question.lstQuestionValueDataView[0].Value!;
            }
          }
        })
      }
      if (updatedNonMEPEditableQuestion) {
        this.section.Questions.forEach(x => {
          if (x.Id == questionId) {
            if (updatedNonMEPEditableQuestion?.question.lstQuestionValueDataView[0].Value == '') {
              let deletedComment:string  = x.lstQuestionValueDataView[0]?.Value.split("|")[4];                                          
              let changedField: string = this.section.SectionID + ',' + questionId;
              this.setTrackingHistory2(x.Id,x.Name,'Deleted : ' + deletedComment);

              x.lstQuestionValueDataView[0].Value = '';
              this.nonMEPEditableQuestions = this.nonMEPEditableQuestions.filter((g: EditableQuestion) => g.question.Id != questionId);     
              
            }
            else {
              let editedComment:string =x.lstQuestionValueDataView[0]?.Value.split("|")[4];              
              let changedField: string = this.section.SectionID + ',' + questionId;
              if(editedComment?.length>=1)                              
                this.setTrackingHistory2(x.Id,x.Name,editedComment);
              
              x.lstQuestionValueDataView[0].Value = updatedNonMEPEditableQuestion?.question.lstQuestionValueDataView[0].Value!;

            }
          }
        })
      }


      //this.goalEditableQuestions = this.goalEditableQuestions.filter((g: EditableQuestion) => g.question.Id != questionId);
      //this.nonMEPEditableQuestions = this.nonMEPEditableQuestions.filter((g: EditableQuestion) => g.question.Id != questionId);
    }
    this.shared.updateSections(this.section,0);
    this.shared.updateCacheSection(this.section);
    this.fireValidation();
  }

  IdentifyChange(): boolean {
    let returnVal: boolean = false;
    this.section.Questions.forEach(quest => {
      if (quest.Id == 471) {
        let prevValueIds = quest.lstQuestionValueDataView[0].Value.split(',');
        if (prevValueIds.length == 1 && prevValueIds[0] == '') {
          prevValueIds = [];
        }
        let newValueIds = this.lstInstructionalService.map((x => x.ID.toString()));

        const deletedIds = prevValueIds.filter(x => !newValueIds.includes(x));
        if (deletedIds.length >= 1) {
          let changedField: string = this.section.SectionID + ',' + quest.Id;
          let deletedServiceName: string[] = this.findModifiedServiceName(deletedIds, 1);
          this.setTrackingHistory(changedField, 'Deleted ', deletedServiceName);
          returnVal = true;
        }

        const newIds = newValueIds.filter(x => !prevValueIds.includes(x));
        if (newIds.length >= 1) {
          let changedField: string = this.section.SectionID + ',' + quest.Id;
          let newServiceName: string[] = this.findModifiedServiceName(newIds, 1);
          this.setTrackingHistory(changedField, 'Added ', newServiceName);
          returnVal = true;
        }
      }
      if (quest.Id == 472) {
        let prevValueIds = quest.lstQuestionValueDataView[0].Value.split(',');
        if (prevValueIds.length == 1 && prevValueIds[0] == '') {
          prevValueIds = [];
        }
        let newValueIds = this.lstSupportService.map((x => x.ID.toString()));

        const deletedIds = prevValueIds.filter(x => !newValueIds.includes(x));
        if (deletedIds.length >= 1) {
          let changedField: string = this.section.SectionID + ',' + quest.Id;
          let deletedServiceName: string[] = this.findModifiedServiceName(deletedIds, 2);
          this.setTrackingHistory(changedField, 'Deleted ', deletedServiceName);
          returnVal = true;
        }

        const newIds = newValueIds.filter(x => !prevValueIds.includes(x));
        if (newIds.length >= 1) {
          let changedField: string = this.section.SectionID + ',' + quest.Id;
          let newServiceName: string[] = this.findModifiedServiceName(newIds, 2);
          this.setTrackingHistory(changedField, 'Added ', newServiceName);
          returnVal = true;
        }
      }
    })

    return returnVal;
  }

  setTrackingHistory2(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory2(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }

  setTrackingHistory(changedField: string, action: string, deletedIds: string[]) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTracking(changedField, action, deletedIds);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }
  findModifiedServiceName(deletedIds: string[], type: number): string[] {
    const obj: string[] = [];
    if (type == 1) {
      this.lookupInstructionalService.map((s: ServiceName) => {
        deletedIds.map((id: string) => {
          if (Number(id) == s.ID) {
            obj.push(s.SERVICE_NAME);
          }
        });

      });
    }
    else if (type == 2) {
      this.lookupSupportService.map((s: ServiceName) => {
        deletedIds.map((id: string) => {
          if (Number(id) == s.ID) {
            obj.push(s.SERVICE_NAME);
          }
        });

      });
    }
    return obj;
  }

}



/*export interface PeriodicElement {
  position: number;
  name: string;

}*/



